module.exports = __webpack_public_path__ + "static/media/Absa-Digital-Proposition-2.d3b02f8a.gif";